import { SeverityLevelContact } from './severity-level-contacts';

export const MSC_SEVERITY_LEVEL_CONTACTS: SeverityLevelContact[] = [
  {
    severity: '1<sup>st</sup> Level',
    contacts: [
      {
        name: 'MSC Engineer On Duty',
        phones: [{ number: '+1 855 661 5571', type: 'OFF' }],
        email: 'CBNmsc@comcast.com',
      },
      {
        name: 'NOC Engineer On Duty',
        phones: [{ number: '+1 866 892 0915', type: 'OFF' }],
        email: 'CBNnoc@comcast.com',
      },
    ],
  },
  {
    severity: '2<sup>nd</sup> Level',
    link: '2nd-level',
    contacts: [
      {
        name: 'Patti Annis',
        title: 'MSC Director',
        phones: [
          { number: '+1 773 661 5571', type: 'OFF' },
          { number: '+1 773 895 2884', type: 'CEL' },
        ],
        email: 'Patricia_Annis@comcast.com',
      },
      {
        name: 'Jason Wiley',
        title: 'Sr. Director, Escalations Management',
        phones: [
          { number: '+1 312 253 4368', type: 'OFF' },
          { number: '+1 312 656 3481', type: 'CEL' },
        ],
        email: 'Jason_Wiley@comcast.com',
      },
    ],
  },
  {
    severity: '3<sup>rd</sup> Level',
    link: '3rd-level',
    contacts: [
      {
        name: 'Lawrence Edmond',
        title: 'SVP of Engineering',
        phones: [
          { number: '+1 773 364 3189', type: 'OFF' },
          { number: '+1 219 798 6414', type: 'CEL' },
        ],
        email: 'Lawrence_Edmond@comcast.com',
      },
    ],
  },
  {
    severity: '4<sup>th</sup> Level',
    link: '4th-level',
    contacts: [
      {
        name: 'Margi Shaw',
        title: 'CEO',
        phones: [{ number: '+1 630 800 9275', type: 'CEL' }],
        email: 'CBNceo@comcast.com',
      },
    ],
  },
];
